var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsPayIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00195 29.7234C2.00195 33.1454 7.54995 35.9234 14.394 35.9234C21.238 35.9234 26.786 33.1494 26.786 29.7234C26.786 26.2974 21.238 23.5234 14.394 23.5234C7.54995 23.5234 2.00195 26.3024 2.00195 29.7234Z",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00195 29.7227V42.1147C2.00195 45.5367 7.54895 48.3147 14.394 48.3147C21.239 48.3147 26.786 45.5407 26.786 42.1147V29.7227",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.786 35.918C26.786 39.34 21.239 42.118 14.394 42.118C7.54895 42.118 2.00195 39.344 2.00195 35.918",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.982 32.8218H45.374C46.1962 32.8218 46.9847 32.4952 47.566 31.9139C48.1474 31.3325 48.474 30.544 48.474 29.7218V4.93984C48.474 4.11767 48.1474 3.32918 47.566 2.74781C46.9847 2.16645 46.1962 1.83984 45.374 1.83984H5.1C4.27783 1.83984 3.48933 2.16645 2.90797 2.74781C2.32661 3.32918 2 4.11767 2 4.93984V20.4398",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.041 17.3337C19.0396 16.2963 19.2984 15.2751 19.7939 14.3637C20.2894 13.4523 21.0057 12.6797 21.8772 12.1169C22.7486 11.554 23.7474 11.2188 24.7819 11.142C25.8165 11.0652 26.8538 11.2492 27.7988 11.6772C28.7438 12.1052 29.5663 12.7635 30.191 13.5917C30.8157 14.42 31.2225 15.3917 31.3743 16.418C31.5261 17.4442 31.4179 18.4922 31.0597 19.4658C30.7015 20.4394 30.1047 21.3075 29.324 21.9907",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74714 8.8125C9.90023 8.8125 10.0499 8.85789 10.1772 8.94294C10.3044 9.02799 10.4036 9.14887 10.4622 9.2903C10.5208 9.43173 10.5361 9.58736 10.5063 9.7375C10.4764 9.88764 10.4027 10.0256 10.2944 10.1338C10.1862 10.242 10.0483 10.3158 9.89814 10.3456C9.748 10.3755 9.59238 10.3602 9.45095 10.3016C9.30952 10.243 9.18864 10.1438 9.10359 10.0165C9.01854 9.88923 8.97314 9.73958 8.97314 9.5865C8.97314 9.38122 9.05469 9.18435 9.19984 9.0392C9.345 8.89405 9.54187 8.8125 9.74714 8.8125Z",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7271 24.3008C40.8802 24.3008 41.0299 24.3462 41.1571 24.4312C41.2844 24.5163 41.3836 24.6372 41.4422 24.7786C41.5008 24.92 41.5161 25.0756 41.4863 25.2258C41.4564 25.3759 41.3827 25.5138 41.2744 25.6221C41.1662 25.7303 41.0283 25.8041 40.8781 25.8339C40.728 25.8638 40.5724 25.8485 40.4309 25.7899C40.2895 25.7313 40.1686 25.6321 40.0836 25.5048C39.9985 25.3775 39.9531 25.2279 39.9531 25.0748C39.9531 24.8695 40.0347 24.6726 40.1798 24.5275C40.325 24.3823 40.5218 24.3008 40.7271 24.3008Z",
    stroke: "#99C93B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsPayIconGreen);
export default __webpack_public_path__ + "static/media/fs-pay-icon-green.cc929b5fcfdf2edda35ab65c4fd7954b.svg";
export { ForwardRef as ReactComponent };